export default "__VITE_ASSET__D_9RtAPT__"